export enum CHECKOUT_CHECKPOINT {
    info = 'info',
    shipping = 'shipping',
    billing = 'billing',
    review = 'review',
    confirmation = 'confirmation',
}
